module.exports = __webpack_public_path__ + "public/img/imgs3.1cb43b56.jpg";